export const PRICE_PER_STATE = 350;
export const NATIONWIDE_MONTHLY_MARKETING_PRICE = 6000;
export const NATIONWIDE_MONTHLY_ACTUAL_PRICE = 4000;
export const MIN_STATES_PER_SUBSCRIPTION = 3;